<template>
  <div
    v-if="tp >1"
    class="flex justify-center flex-wrap pagination"
  >
    <VIcon
      v-if="currentPage > 1"
      class="pagination__jump"
      icon="i-tabler-chevron-left"
      :iconSize="16"
      unselectable="on"
      key="left"
      @click="goPrev"
    />

    <span
      v-if="showStartFakePageNum"
      class="pagination__jump"
      key="page-one"
      @click="jumpPage(1)"
    >1</span>

    <span
      class="ellipsis"
      v-if="showStartFakePageNum && indexes[0] > 2"
      key="ellipsis-front"
    >...</span>

    <span
      class="pagination__jump"
      v-for="num in indexes"
      :key="`page-${num}`"
      :class="{'pagination__jump--active': currentPage == num}"
      @click="jumpPage(num)"
    >{{num}}</span>

    <span
      class="ellipsis"
      key="ellipsis-back"
      v-if="showLastFakePageNum && (tp - (indexes.at(-1) as number) > 1)"
    >...</span>

    <span
      v-if="showLastFakePageNum"
      class="pagination__jump"
      key="page-lastest"
      @click="jumpPage(tp)"
    >{{tp}}</span>

    <VIcon
      v-if="currentPage < tp"
      class="pagination__jump"
      key="right"
      icon="i-tabler-chevron-right"
      :iconSize="16"
      @click="goNext"
    />

    <span
      class="pagination__input"
      key="input">
      <input type="text" v-model="targetPage">
    </span>

    <span
      class="pagination__jump pagination__jump--go"
      key="go"
      @click="jumpPage(targetPage)"
    >Go</span>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

const props = defineProps({
  currentPage: {
    type: Number,
    default: 1
  },
  pageSize: {
    type: Number,
    default: 10
  },
  total: {
    type: Number,
    default: 0
  },
  totalPage: {
    type: Number,
    default: 0
  }
})
const emits = defineEmits(['change'])

const targetPage = ref(null)

const tp = computed(() => {
  return Math.ceil(props.total / props.pageSize)
})


const showStartFakePageNum = computed(() => {
  return efont.value && !indexes.value.includes(1)
})

const showLastFakePageNum = computed(() => {
  return efont.value && !indexes.value.includes(tp.value)
})

const efont = computed(() => {
  return tp.value > 7
})

const indexes = computed(() => {
  const ar : number[] = []
  let left = 1
  let right = tp.value
  if (tp.value >= 7) {
    if (props.currentPage > 5 && props.currentPage < tp.value - 4) {
      left = Number(props.currentPage) - 3
      right = Number(props.currentPage) + 3
    } else {
      if (props.currentPage <= 5) {
        left = 1
        right = 7
      } else {
        right = tp.value

        left = tp.value - 6
      }
    }
  }
  while (left <= right) {
    ar.push(left)
    left++
  }
  return ar
})

const jumpPage = (page) => {
  const p = parseInt(page)

  if (p <= tp.value && p > 0) {
    emits('change', p)
    return
  }

  alert(`请输入大于0，并且小于等于${tp.value}的页码！`)
}

const goPrev = () => {
  let currentPage = props.currentPage
  if (currentPage > 1) {
    emits('change', --currentPage)
  }
}

const goNext = () => {
  let currentPage = props.currentPage
  if (currentPage < tp.value) {
    emits('change', ++currentPage)
  }
}
</script>

<style lang="scss">
.pagination__jump,
.pagination__input {
  @apply inline-flex mr-2 mb-2 w-6 h-6 items-center justify-center rounded-lg cursor-pointer border-primary border border-solid max-w-xs text-base;
}
.pagination__jump {
  @apply hover:bg-primary/90 hover:text-white;
  &--active {
    @apply bg-primary/90 text-white;
  }
  &--go {
    @apply px-1 w-auto;
  }
}
.pagination__input {
  @apply w-16 px-1;
  input {
    @apply w-full outline-none text-base;
  }
}
</style>